<th (click)="sortWasClicked($event)">
    {{title}}
    <span *ngIf="active" class="caret sorter" [ngClass]="{'descending': !isAscending, 'ascending': isAscending}"></span>
</th>